import {
  ON_MY_EVENTS_STATUS_FILTER_CHANGE,
  UPDATE_SEARCH_TEXT,
  ON_SHOW_LOADING_STATE
} from '../actions.js';

const initialState = 'POSTED';

export default (state = initialState, action) => {
  if (action.type === ON_MY_EVENTS_STATUS_FILTER_CHANGE) {
    return action.payload;
  }

  if (action.type === UPDATE_SEARCH_TEXT || action.type === ON_SHOW_LOADING_STATE) {
    return '';
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/my-events/reducers/selected-status.js